import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

function NotDefined({ position = "", positionType = "Producer" }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={[]}
			cacheManagement={{
				clearAbsoluteIndexes: ["payPlansSidebarTree", "payPlanSalesPerformanceReportVersions"],
			}}
		>
			No Model
		</PayPlansFacade>
	);
}
NotDefined.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
};

export default NotDefined;
